// document.addEventListener('DOMContentLoaded', function () {
//     const img = document.querySelector('#zoom-container img');
//     const container = document.querySelector('#zoom-container');
//     const body = document.querySelector('body');

//     if (img && container && body) {
//         let currentScale = 1;
//         let prevZoom = 0;

//         container.addEventListener('wheel', (event) => {
//             prevZoom = currentScale;
//             const deltaY = event.deltaY;
//             const zoomSpeed = 0.05; // Zoom speed
//             const zoomLevel = parseInt(container.dataset.zoomLevel); // Get the zoom level from data attribute

//             if (deltaY !== 0) {

//                 // Calculate new zoom factor
//                 let zoomFactor = deltaY > 0 ? 1 + zoomSpeed : 1 - zoomSpeed;
//                 const newScale = currentScale * zoomFactor;
//                 // Limit zoom factor based on zoom level
//                 if (newScale >= 1 && newScale <= zoomLevel && window.scrollY === 0) {
//                     event.preventDefault(); // Prevents default scroll behavior
//                     currentScale = newScale;
//                     img.style.transform = `scale(${currentScale})`;
//                 } else if (newScale < 1) {
//                     currentScale = 1;
//                     img.style.transform = 'scale(1)';
//                 } else {
//                     body.scrollTop += event.deltaY;
//                     zoomFactor = 0;
//                 }
//             }
//         });
//     }
// });
